import api from '../../api'
import { CommercialStructureApi } from './interfaces'

export * from './interfaces'

export const getCommercialStructureData = async (): Promise<CommercialStructureApi[]> => {
  const response = await api.get('estrut-comerc/v2/ListarEstruturaComercial')

  return response.data
}
